export default __webpack_public_path__ + "static/1267-e805bca2acc3999c04f4adb809344482.gif";